import React from 'react';
import Title from './UI/Title';
import Card from './UI/Card';

import { GiFactory, GiSolarPower, GiPlug } from 'react-icons/gi';
import { FaRegChartBar, FaSearchDollar } from 'react-icons/fa';

export default function EnergyStorage() {
  const details = [
    {
      icon: <FaSearchDollar className='h-12 w-12' />,
      name: 'מחירי תעו"ז פסגה/שפל',
      description: 'הפרש מחירים של עד פי 4 בין הפסגה לשפל',
    },
    {
      icon: <FaRegChartBar className='h-12 w-12' />,
      name: 'Peak Shaving',
      description: 'הייצור מקסימאלי בשעות השפל ואילו בשעות העומס אין מענה',
    },
    {
      icon: <GiFactory className='h-12 w-12' />,
      name: 'Resilience',
      description: 'ביזור ועצמאות מקורות הייצור',
    },
    {
      icon: <GiPlug className='h-12 w-12' />,
      name: 'בעיית הולכת רשת',
      description: 'מרבית הייצור הסולארי בדרום הארץ. יש מצוקת מקום ברשת ההולכה',
    },
    {
      icon: <GiSolarPower className='h-12 w-12' />,
      name: 'בעיות בתדר הרשת',
      description: 'חשמל סולארי לא יציב בגלל עננות ואתרים מרובים. חחי זקוקה לפתרון המייצב את התדר',
    },
  ];

  return (
    <>
      <Title>אגירת אנרגיה</Title>
      <div className='mx-auto max-w-6xl'>
        <h1 className=' font-secular text-2xl md:text-3xl text-center md:text-right mt-10 '>האתגרים:</h1>

        <div className='py-8 bg-white'>
          <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
            <div className='mt-10'>
              <div className='space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10'>
                {details.map((propsOb) => (
                  <div key={propsOb.name} className='relative text-center md:text-right'>
                    <Card icony={propsOb.icon} name={propsOb.name} description={propsOb.description} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
